import React from 'react';
import {
  Box, Typography, ToggleButton, ToggleButtonGroup,
} from '@mui/material';
import { CATEGORY_COLORS } from './constants';

/**
 * Color filter panel for the seating toolbar.
 *
 * Props:
 *   activeFilter  – 'none' | 'side' | 'category'
 *   onFilterChange – (newFilter) => void
 */
export default function ColorFilterPanel({ activeFilter, onFilterChange }) {
  return (
    <Box>
      <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
        Szín szűrő
      </Typography>

      <ToggleButtonGroup
        value={activeFilter}
        exclusive
        onChange={(_, val) => { if (val !== null) onFilterChange(val); }}
        size="small"
        fullWidth
        orientation="vertical"
        sx={{ gap: 0.5 }}
      >
        <ToggleButton value="none" sx={{ justifyContent: 'flex-start', gap: 1, fontSize: 11 }}>
          <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#e0e0e0', border: '1px solid #9e9e9e' }} />
          Nincs szűrő
        </ToggleButton>
        <ToggleButton value="side" sx={{ justifyContent: 'flex-start', gap: 1, fontSize: 11 }}>
          <Box sx={{ display: 'flex', gap: 0.25 }}>
            <Box sx={{ width: 6, height: 12, borderRadius: '2px 0 0 2px', bgcolor: CATEGORY_COLORS.bride }} />
            <Box sx={{ width: 6, height: 12, borderRadius: '0 2px 2px 0', bgcolor: CATEGORY_COLORS.groom }} />
          </Box>
          Menyasszony / Vőlegény
        </ToggleButton>
        <ToggleButton value="category" sx={{ justifyContent: 'flex-start', gap: 1, fontSize: 11 }}>
          <Box sx={{ display: 'flex', gap: 0.25 }}>
            {Object.values(CATEGORY_COLORS).slice(0, 4).map((c, i) => (
              <Box key={i} sx={{ width: 3, height: 12, bgcolor: c, borderRadius: 1 }} />
            ))}
          </Box>
          Kategóriák
        </ToggleButton>
      </ToggleButtonGroup>

      {/* Legend */}
      {activeFilter !== 'none' && (
        <Box sx={{ mt: 1.5 }}>
          <Typography variant="caption" color="text.secondary" fontWeight={600}>
            Jelmagyarázat
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.4, mt: 0.5 }}>
            {activeFilter === 'side' ? (
              <>
                <LegendRow color={CATEGORY_COLORS.bride} label="Menyasszony oldala" />
                <LegendRow color={CATEGORY_COLORS.groom} label="Vőlegény oldala" />
                <LegendRow color={CATEGORY_COLORS.default} label="Nincs besorolva" />
              </>
            ) : (
              Object.entries(CATEGORY_COLORS).map(([key, color]) => (
                key !== 'default' && <LegendRow key={key} color={color} label={key} />
              ))
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
}

function LegendRow({ color, label }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />
      <Typography variant="caption" sx={{ fontSize: 10 }}>{label}</Typography>
    </Box>
  );
}
